import { DEFAULT_PAGE_SIZE } from '../constants/pagination'
import { Organization } from '../types'
import { apiService } from './api.service'

export interface OrganizationListResponse {
  count: number
  next: string | null
  previous: string | null
  results: Organization[]
}

class OrganizationService {
  async listAll(params?: { [key: string]: any }): Promise<OrganizationListResponse> {
    const queryParams = new URLSearchParams()
    const mergedParams: Record<string, any> = { page: 1, page_size: DEFAULT_PAGE_SIZE, ...(params || {}) }
    Object.keys(mergedParams).forEach((key) => {
      const value = mergedParams[key]
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, String(value))
      }
    })
    const response = await apiService.get<OrganizationListResponse>(`organizations/?${queryParams.toString()}`)
    return response.data
  }

  async create(data: Partial<Organization>): Promise<Organization> {
    const response = await apiService.post<Organization>('organizations/', data)
    return response.data
  }

  async update(id: number, data: Partial<Organization>): Promise<Organization> {
    const response = await apiService.patch<Organization>(`organizations/${id}/`, data)
    return response.data
  }

  async delete(id: number): Promise<void> {
    await apiService.delete(`organizations/${id}/`)
  }
}

export const organizationService = new OrganizationService()
